// generated from 1_216 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasNeverReceivedCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_never_received_campaign_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 649 (53.37%), defined 567 (46.63%)
  // true 543 (95.77%), false 24 (4.23%)
  raw_value: z.boolean().optional(),
  // true 1_146 (94.24%), false 70 (5.76%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
